import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, formatApiError } from "@/lib/saathiClient";

export default function OrgLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await authApi.post("/auth/login", { email, password });
      nav("/org");
    } catch (err) {
      setError(formatApiError(err));
    }
    setBusy(false);
  };

  const input = "w-full bg-white border border-[#EDE0D4] rounded-2xl px-4 py-3.5 text-[15px] text-[#1A1A2E] focus:outline-none focus:border-[#E07B39] focus:ring-2 focus:ring-[#E07B39]/20 transition-colors";

  return (
    <div className="saathi-page" data-testid="org-login-page">
      <div className="saathi-texture" />
      <div className="max-w-md mx-auto w-full px-7 sm:px-10 py-12 relative z-10 min-h-screen flex flex-col">
        <a href="/" className="font-mono text-xs tracking-wider text-[#8B7355] hover:text-[#1A1A2E]" data-testid="org-login-back-link">← Saathi</a>
        <div className="mt-20 welcome-stagger">
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#E07B39] mb-3 stag-1">partner portal</div>
          <h1 className="font-heading text-[48px] leading-[0.95] tracking-tight text-[#1A1A2E] mb-4 stag-2">Welcome back.</h1>
          <p className="text-[15px] leading-relaxed text-[#1A1A2E]/75 mb-10 stag-3">
            For libraries, hospitals, settlement agencies and government offices running Saathi for their community.
          </p>
          <form onSubmit={submit} className="space-y-3 stag-4" data-testid="org-login-form">
            <input type="email" required placeholder="work email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="org-login-email-input" />
            <input type="password" required placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="org-login-password-input" />
            {error && <div className="text-[13px] text-[#B4441C]" data-testid="org-login-error">{error}</div>}
            <button disabled={busy} className="w-full bg-[#E07B39] hover:bg-[#c96a2e] disabled:opacity-60 text-white font-medium text-[16px] rounded-full py-4 min-h-[56px] transition-colors active:scale-[0.98] shadow-[0_8px_24px_-8px_rgba(224,123,57,0.5)]" data-testid="org-login-submit-btn">
              {busy ? "Signing in…" : "Sign in →"}
            </button>
          </form>
          <p className="mt-8 font-mono text-[11px] text-[#8B7355] leading-relaxed">
            No account yet? Write to <a href="mailto:hello@hikarigrove.com" className="text-[#E07B39]" data-testid="org-login-contact-link">hello@hikarigrove.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}
